import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { globalEnv } from "~/global-env";
import {
  cellContainer,
  inLabel,
  launchIcon,
  launchIconContainer,
  positionNameWrapper,
} from "./styles_vanilla.css";

type Props = {
  account: string;
  entity: string;
  positionId?: number | null;
  arenaId?: number | null;
  entityId?: number | null;
};

const PositionNameRenderer = ({ account, entity, positionId, arenaId, entityId }: Props) => {
  const canLink = positionId != null && arenaId != null && entityId != null;

  const handleLaunch = (e: React.MouseEvent<HTMLOrSVGElement>) => {
    e.stopPropagation();
    const params = new URLSearchParams({
      positionIds: String(positionId),
      entityId: String(entityId),
      arenaIds: String(arenaId),
    });
    window.open(`/canopy${globalEnv.complianceRoute}/positions?${params.toString()}`, "_blank");
  };

  return (
    <div className={cellContainer}>
      <Flex flexDirection="row" gap={Sizes.XS} className={positionNameWrapper}>
        <Text variant="strong-md">{account}</Text>
        <Text variant="secondary-md" className={inLabel}>
          in
        </Text>
        <Text variant="strong-md">{entity}</Text>
      </Flex>
      {canLink && (
        <Flex alignItems="center" className={launchIconContainer}>
          <HelpIndicator
            id={`position-launch-${positionId}-tooltip`}
            placement="top"
            content="View position"
          >
            <Icon
              type="external-link"
              variant="outline"
              color={Colors.Primary600}
              onClick={handleLaunch}
              className={launchIcon}
            />
          </HelpIndicator>
        </Flex>
      )}
    </div>
  );
};
export default PositionNameRenderer;
